import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { MultiselectWithSearchModule } from '@shared/components';
import { FormFieldModule } from '../form-field/form-field.module';
import { AlphabetPickerComponent } from './alphabet-picker.component';



@NgModule({
  declarations: [
    AlphabetPickerComponent,
  ],
  exports: [
    AlphabetPickerComponent,
  ],
  imports: [
    CommonModule,
    FormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    TranslateModule,
    MatInputModule,
    MatSelectModule,
    MultiselectWithSearchModule,
  ],
})
export class AlphabetPickerModule { }
